import ContentHeader from '@/components/ContentHeader';
import { modalType } from '@/components/Modal';
import { CDN2 } from '@/helpers/api';
import { basicPageProps, fetchTemplate } from '@/utils/isServer';
import { Button, Form, Input } from 'antd';
import { GetServerSideProps } from 'next';
import Head from 'next/head';
import React, { useState } from 'react';

const { TextArea } = Input;

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const { airports } = await basicPageProps(ctx);

  return {
    props: {
      airports,
    },
  };
};

export default function Reviews() {
  const [sendingForm, setSendingForm] = useState(false);
  const [form] = Form.useForm();

  function handleSubmit(values: any) {
    setSendingForm(true);
    const params = {
      name: values.name,
      email: values.email,
      phone: values.phone,
      message: values.message,
    };

    fetch('/api/SendGrid/Reviews', {
      ...fetchTemplate,
      method: 'POST',
      body: JSON.stringify(params),
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((success) => {
        console.log(success);
        setSendingForm(false);
        form.resetFields();
        modalType({
          type: 'success',
          title: 'Success',
          content: (
            <div className="text-left">
              <p>Review Submitted</p>
              <p>Thank you for your review!</p>
            </div>
          ),
        });
      })
      .catch((error) => {
        console.log(error);
        setSendingForm(false);
      });
  }

  return (
    <div>
      <Head>
        <title>Airport Parking Reviews | On Air Parking</title>
        <meta
          name="description"
          content="Cheap Airport Parking Reviews | Discount Rate Reviews at International Airports"
          key="description"
        />
        <meta
          property="og:url"
          content="https://www.onairparking.com/reviews"
          key="og:url"
        />
        <meta property="og:type" content="website" key="og:type" />
        <meta
          property="og:title"
          content="Airport Parking Reviews | On Air Parking"
          key="og:title"
        />
        <meta
          property="og:description"
          content="Cheap Airport Parking Reviews | Discount Rate Reviews at International Airports"
          key="og:description"
        />
        <meta
          property="og:image"
          content={CDN2() + '/staticmyapp/oglogo-white.png'}
          key="og:image"
        />
      </Head>
      <ContentHeader btitle="Reviews" />
      <div className="bg-white">
        <div className="container max-w-4xl px-4 mx-auto py-12">
          <p className="text-center max-w-md mx-auto text-lg">
            We deeply value our customers reviews, please check out our warm
            review at:{' '}
            <a
              href="https://www.facebook.com/ParkOnAir/"
              rel="noopener noreferrer"
              target="_blank"
              className="text-primary underline"
            >
              Facebook
            </a>
          </p>
          <p className="text-center font-bold my-8 text-xl">
            Or Send Us a Review
          </p>
          <div className="p-4 rounded-md mt-8 max-w-xl border mx-auto bg-gray-100">
            <Form
              form={form}
              id="crypto-form"
              className=""
              layout="vertical"
              onFinish={handleSubmit}
            >
              <Form.Item
                name="name"
                label="Name"
                rules={[
                  {
                    type: 'string',
                    required: true,
                    message: 'Please input your Name!',
                  },
                ]}
                htmlFor="name"
              >
                <Input id="name" name="name" type="text" />
              </Form.Item>
              <Form.Item
                name="email"
                label="Email"
                rules={[
                  {
                    type: 'email',
                    required: true,
                    message: 'Not a valid email!',
                  },
                ]}
                htmlFor="email"
              >
                <Input id="email" name="email" type="text" />
              </Form.Item>
              <Form.Item
                name="phone"
                label="Phone"
                rules={[
                  {
                    type: 'string',
                    required: true,
                    message: 'Please input your Phone!',
                  },
                ]}
                htmlFor="phone"
              >
                <Input id="phone" name="phone" type="text" />
              </Form.Item>
              <Form.Item
                name="message"
                label="Message"
                rules={[
                  {
                    type: 'string',
                    required: true,
                    message: 'Please write a message!',
                  },
                ]}
                htmlFor="message"
              >
                <textarea
                  id="message"
                  name="message"
                  rows={4}
                  className={`w-full border rounded border-gray-250 ring-0 hover:border-primary focus:shadow-md focus:border-none focus:ring-2 focus:border-primary focus:ring-yellow-500 focus:ring-opacity-20 focus:outline-none ${
                    form.getFieldError('message').length > 0
                      ? 'border-red-500 shadow-md ring-2 ring-red-200'
                      : ''
                  }`}
                />
              </Form.Item>
              <Button
                htmlType="submit"
                type="primary"
                size="large"
                className="px-8 mx-auto bg-primary block uppercase rounded-full mt-8 mb-4"
                loading={sendingForm}
              >
                Submit
              </Button>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
}
